import { Server } from '@form-engine/bso-cxp-attachments-client/dist/server';
import { FormEnginePlugin } from '@form-engine/core-application';
import { AuthType } from '@form-engine/core-util/request';
import BsoFormEngineRenderer from './components/form/renderer';
import './utilities/declare-csp-api';

declare module '@form-engine/core-application/types/form' {
    interface FormDefinition {
        bsoEnvironment?: keyof typeof Server;
        bsoAuth?: AuthType | '';
        bsoBasicAuthUsername?: string;
        bsoBasicAuthPassword?: string;
        bsoBearerToken?: string;
        bsoTheme?: string;
    }
}

export default {
    rendererComponent: BsoFormEngineRenderer,
} as FormEnginePlugin;
